module.exports = __webpack_public_path__ + "img/examination-pic2.5f5a04cb.png";